import { getFetch } from '../fetch';
import { apiConfig } from '../config';

import { GetModuleLessonsRequestData, ModuleLessons } from '../../../typings';

export function getModuleLessons(data: GetModuleLessonsRequestData): Promise<ModuleLessons> {
    const { apiGetModuleLessons } = apiConfig.getStaticUrls();
    const serverParams = {
        course_id: data.courseId,
        page: data.page,
        page_size: data.pageSize || 100,
    };

    return getFetch(`${apiGetModuleLessons}${data.moduleId}/`, { ...serverParams });
}
